import { useRef } from 'react';
import { Button } from './Button.js';
import { Dialogue } from './Dialogue.js';

/**
 * Une confirmation bloquante. Le focus arrive sur le bouton qui confirme : Entrée confirme,
 * Échap annule — les deux viennent du <dialog> natif, sans écouteur de clavier ici.
 */
export function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  variant = 'danger',
  onConfirm,
  onCancel,
}: {
  open: boolean;
  title: string;
  message?: React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  variant?: 'danger' | 'primary';
  onConfirm: () => void;
  onCancel: () => void;
}): React.ReactElement | null {
  const confirmRef = useRef<HTMLButtonElement>(null);
  return (
    <Dialogue
      open={open}
      onClose={onCancel}
      title={title}
      size="sm"
      hideClose
      initialFocusRef={confirmRef}
      footer={
        <>
          <Button variant="ghost" onClick={onCancel}>
            {cancelLabel}
          </Button>
          <Button ref={confirmRef} variant={variant} onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </>
      }
    >
      {message && <p className="discret">{message}</p>}
    </Dialogue>
  );
}
